// 负责处理与组织相关的api
import ApiBase from './api_base'
import lodash from 'lodash'

export default class OrganizationApi {
  static members(params) {
    return ApiBase.get(`/organizations/${params.orgId}/members`, lodash.pick(params, ['page']))
  }

  static logs(params) {
    return ApiBase.get(`/organizations/${params.orgId}/security_logs`, lodash.pick(params, ['page']))
  }

  static stats(params) {
    return ApiBase.get(`/organizations/${params.orgId}/stats`, lodash.pick(params, ['period']))
  }

  static editMember(params) {
    return ApiBase.put(`/organizations/${params.orgId}/members/${params.memId}`, {
      member: lodash.pick(params, ['department', 'role', 'permissions'])
    })
  }

  static removeMember(params) {
    return ApiBase.delete(`/organizations/${params.orgId}/members/${params.memId}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/organization.js